import { Field, FieldProps } from 'formik';
import React from 'react';
import { Form, FormControlProps } from 'react-bootstrap';
import { ErrorI18n } from '../error';

export type TextareaProps = Omit<
  FormControlProps &
    React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
      controlId?: string;
      label?: string;
      className?: string;
      showValidation?: boolean;
      showError?: boolean;
    },
  'type' | 'as' | 'value' | 'title' | 'onChange' | 'onBlur' | 'children'
>;

export const Textarea = ({
  controlId,
  label,
  className = '',
  showValidation = true,
  showError = true,
  ...additionalAttributes
}: TextareaProps) => {
  return (
    <div className={`input${className ? ` ${className}` : ''}`}>
      <Field name={controlId}>
        {({ field, meta }: FieldProps) => (
          <Form.Group controlId={controlId} className="form-group">
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Control
              as="textarea"
              value={field.value || ''}
              onChange={field.onChange}
              onBlur={field.onBlur}
              isValid={showValidation && !meta.error && meta.touched}
              isInvalid={showValidation && !!meta.error && meta.touched}
              title={field.value || ''}
              {...additionalAttributes}
            />
            {showError && <ErrorI18n {...meta} />}
          </Form.Group>
        )}
      </Field>
    </div>
  );
};
